<template>
  <PageHeader title="Dashboard" subtitle="System overview and statistics" />

  <div class="dashboard-container pa-30px">
    <div v-if="stats">
      <!-- User metrics -->
      <DashboardItemWrapper title="User metrics" no-margin>
        <DashboardItem title="Total Users" :value="stats.users.total" />
        <DashboardItem title="New Users (30 days)" :value="stats.users.new" />
        <DashboardItem title="Active Users" :value="stats.users.active" />
      </DashboardItemWrapper>

      <!-- Reports created (last 30 days) -->
      <DashboardItemWrapper title="Reports created (last 30 days)" single-item>
        <DashboardChart :timeline="stats.reports.timeline" />
      </DashboardItemWrapper>

      <!-- Report by status -->
      <DashboardItemWrapper title="Report by status">
        <DashboardItem title="Total Reports" :value="stats.reports.total" />
        <DashboardItem title="New Reports (30 days)" :value="stats.reports.new" />
        <DashboardItem title="Processing" :value="stats.reports.by_status.processing" />
        <DashboardItem title="Completed" :value="stats.reports.by_status.completed" />
        <DashboardItem title="Failed" :value="stats.reports.by_status.failed" />
      </DashboardItemWrapper>

      <!-- Email metrics -->
      <DashboardItemWrapper title="Email metrics">
        <DashboardItem title="Total Emails" :value="stats.emails.total" />
        <DashboardItem title="Delivered" :value="stats.emails.by_status.delivered" />
        <DashboardItem title="Opened" :value="stats.emails.by_status.opened" />
        <DashboardItem title="Bounced" :value="stats.emails.by_status.bounced" />
        <DashboardItem title="Failed" :value="stats.emails.by_status.failed" />
      </DashboardItemWrapper>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

import { useDashboardStats } from "@/composables/useDashboardStats";
import PageHeader from "@/components/PageHeader.vue";
import DashboardItem from "@/components/DashboardItem.vue";
import DashboardItemWrapper from "@/components/DashboardItemWrapper.vue";
import DashboardChart from "@/views/DashboardView/components/DashboardChart.vue";

const { stats, fetchStats } = useDashboardStats();

onMounted(fetchStats);
</script>

<style lang="scss" scoped>
.dashboard-container {
  max-width: 1400px;
  margin: 0 auto;
}
</style>
